<template>
  <div>
    <vs-card class="cstm_vx_card mb-4">
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <div class="md:w-1/2 w-full p-1">
            <vs-input placeholder="Search"  v-model="search"  @keyup="searchFun" class="w-full"></vs-input>
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Filter" position="top">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-filter"
                @click="handlefilterSidebar"
              />
            </vs-tooltip>
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Filter View" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="overallSearch"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <rect width="18" height="18" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14ZM11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.1465 16.3536L13.1465 14.3536L13.8536 13.6465L15.8536 15.6465L15.1465 16.3536Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H15C16.3807 0.5 17.5 1.61929 17.5 3V14.5H16.5V3C16.5 2.17157 15.8284 1.5 15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V15C1.5 15.8284 2.17157 16.5 3 16.5H13.5V17.5H3C1.61929 17.5 0.5 16.3807 0.5 15V3Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.5 5.5H1.5V4.5H16.5V5.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 8.5H1.5V7.5H7.5V8.5ZM16.5 8.5H15V7.5H16.5V8.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.5 11.5H1.5V10.5H6.5V11.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 14.5H1.5V13.5H7.5V14.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.5 16.5V5H5.5V16.5H4.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Rearrange Column" position="top">
              <vs-button
                @click="columnRearrangement"
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                icon="published_with_changes"
              >
              </vs-button>
            </vs-tooltip>
          </div>
          <!-- <div class="p-1">
            <vs-tooltip color="primary" text="Import CSV/ XLS" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="excelModal()"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H22C18.6863 43 16 40.3137 16 37V24.5H18V37C18 39.2091 19.7909 41 22 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 28V32C10 34.2091 11.7909 36 14 36H24V38H14C10.6863 38 8 35.3137 8 32V28H10Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.36396 28.8284L4.41421 33.7782L3 32.364L9.36396 26L15.7279 32.364L14.3137 33.7782L9.36396 28.8284Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Export Template" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="exportApi"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H18C14.6863 43 12 40.3137 12 37V24.5H14V37C14 39.2091 15.7909 41 18 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 26V30C8 32.2091 9.79086 34 12 34H22V36H12C8.68629 36 6 33.3137 6 30V26H8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.8995 34.6569L16.9498 39.6066L18.364 41.0208L24.728 34.6569L18.364 28.2929L16.9498 29.7071L21.8995 34.6569Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div> -->
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-row vs-type="flex" vs-justify="flex-end" vs-align="center">
            <vs-button
              class="btnx"
              @click="reditectToCreateNewView()"
              v-if="checkCreatePermission"
            >
              Create Template
            </vs-button>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-card>

    <div v-if="overallSearchHolder">
      <vs-card class="cstm_vx_card mb-4">
        <div slot="header">
          <h4>Filter View</h4>
        </div>
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="sm:block block lg:flex"
          >
            <div class="lg:w-1/3 w-full p-1">

               <v-select
              placeholder="Select View"
              v-if="user_main_filter"
              class="w-full"
              label="filter_name"
              :options="user_main_filter"
              :reduce="(item) => item.id"
              :clearable="false"
              v-model="select_filter_id"
              @input="getFilterByLead()"
            >
            </v-select>
            </div>
            <div class="flex p-1">
              <vs-tooltip color="primary" text="Reset Filters" position="top">
                <vs-button
                  type="border"
                  icon-pack="feather"
                  @click="resetSearch"
                  icon="icon-refresh-cw"
                ></vs-button>
              </vs-tooltip>
            </div>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>

    <ag-grid-vue
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :frameworkComponents="frameworkComponents"
      :tooltipMouseTrack="true"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="rowData"
      rowSelection="multiple"
      :enableRtl="$vs.rtl"
      colResizeDefault="true"
      :animateRows="true"
      :floatingFilter="false"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      @grid-ready="onGridReady"
      @sortChanged="sortFun"
    >
    </ag-grid-vue>
    <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
      <vs-col vs-w="4" vs-type="flex" vs-justify="start" vs-align="center">
        <!-- page limit select view -->
        <ItemsPerTableDropdown
          tableName="courseWork_template_table"
          @change="(pageLimit) => pageLimitSet = pageLimit"
        />
      </vs-col>
      <pagination :meta="meta" @page-change="handlePageChange" class="ml-auto" />
    </vs-row>

    <vs-popup
      class="popup"
      title="Column Rearrangement"
      :active.sync="columnRearrangementModal"
    >
      <RearrangeManagement
        v-if="columnRearrangementModal"
        moduleProps="Coursework"
        headername="Coursework Template"
        table_name="courseWork_template_table"
        @closeRearrangementModal="closeRearrangementModal"
      ></RearrangeManagement>
    </vs-popup>

    <!-- Filter Sidebar Component -->
    <filter-sidebar
      :isSidebarActive="filterSidebarBoolean"
      :fieldtabledata="fieldtabledata"
      :filterconditiondata="filterconditiondata"
      platformmodulename="Coursework"
      @closedsidebarevent="filterSidebarEvent"
      name="courseWork_template_table"
    ></filter-sidebar>
    <!-- Filter Sidebar Component -->
  </div>
</template>
<script>
import Vue from 'vue'
import Pagination from '@/components/common/pagination'
import CustomTooltip from '../CourseWork/customTooltipVue.js'

import { AgGridVue } from 'ag-grid-vue'
import CellRendererAction from './CellRendererAction'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import RearrangeManagement from '@/views/pages/customFieldRearrage/columnRearrangeWithoutDynamic.vue'


import SubjectComponent from '../CourseWork/SubjectComponent.vue'
import { Subject } from '@/mixins/subject/subject'

import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { checkingAssignment } from '@/mixins/middleware/checkingAssignment'
import { Tag } from '@/mixins/tag/tag'
import { listAssignment } from '@/api/assignment-question'

import vSelect from 'vue-select'
import FilterSidebar from '@/components/common/filter-sidebar'
import { DynamicField } from '@/mixins/dynamic-field'
import { DynamicFilter } from '@/mixins/dynamic-filter'
import { fetchField } from '@/api/columnrearrange.js'


export default {
  mixins: [Tag, Subject, PermissionMiddleware, checkingAssignment, DynamicFilter, DynamicField],

  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Coursework')
    }

    //user_main_filter
    this.fetchMainFilter('Coursework', 'courseWork_template_table')
    this.fetchingDynamicFieldAndFilter()
    this.fetchDisplayFields('Coursework', this.$store.getters.customerId)
  },
  watch: {
    columnRearrangementModal () {
      if (!this.columnRearrangementModal) {
        this.fetchDisplayFields('Coursework', this.$store.getters.customerId)
        this.searchByfilter()
      }
    },
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  data () {
    return {
      displayList:[],
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      search:'',
      pageLimitSet: 5,
      frameworkComponents:null,
      columnDefs:[],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      gridApi: null,
      gridOptions: {
        accentedSort: true
      },
      columnRearrangementModal: false,
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true,
        tooltipComponent: 'customTooltip'
        // autoHeight: true
      },
      rowData: [],
      filterSidebarBoolean: false,
      overallSearchHolder: false,
      select_filter_id: '',
      searchByLeadType: '',
      staticField :[
        {
          headerName: '#',
          field: 'row_index',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
          sortable: false,
          editable: false,
          valueGetter:(params) => {
            return ((this.meta.limit * (this.meta.current_page - 1)) + params.node.rowIndex + 1)
          }
        },
        {
          headerName: 'Title',
          field: 'title',
          filter: true,
          minWidth: 60,
          resizable: true,
          editable: false
        },
        {
          headerName: 'Description',
          field: 'description',
          filter: true,
          minWidth: 120,
          resizable: true,
          editable: false
        },
        {
          headerName: 'Subject',
          field: 'subject',
          filter: true,
          minWidth: 100,
          resizable: true,
          editable: false,
          comparator:(valueA) => {},
          cellRendererFramework: Vue.extend(SubjectComponent),
          tooltipField: 'subject',
          tooltipComponentParams: { color: '#fff' },
          floatingFilterComponentParams: {
            suppressFilterButton: false
          }
        },
        {
          headerName: 'No. of Questions',
          field: 'no_of_questions',
          filter: true,
          minWidth: 100,
          resizable: true,
          editable: false
        },
        {
          headerName: 'Total Marks',
          field: 'total_marks',
          filter: true,
          minWidth: 100,
          resizable: true,
          editable: false,
          comparator:(valueA) => {}
        },
        {
          headerName: 'Actions',
          field: 'actions',
          minWidth: 170,
          maxWidth: 170,
          resizable: true,
          editable: false,
          sortable:false,
          cellRendererFramework: 'CellRendererAction',
          cellRendererParams: {type: 'coursework', fetchAssignmentList:this.fetchAssignmentList}
        }
      ]
    }
  },
  components: {
    AgGridVue,
    CellRendererAction,
    Pagination,
    FilterSidebar,
    vSelect,
    RearrangeManagement
  },
  beforeMount () {
    this.tooltipShowDelay = 0
    this.frameworkComponents = {
      customTooltip:CustomTooltip
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
  },
  methods: {
    async fetchDisplayFields (moduleName, customerId) {
      //
      try {
        const payload = {
          customer_id: customerId,
          fetch_status: 'display',
          type: moduleName,
          table_name:'courseWork_template_table'
        }
        const { data } = await fetchField(payload)
        const displayList = data.data.results

        let displayColomns = []
        if (displayList.length === 0) {
          displayColomns = this.staticField
        } else {
          for (const item of displayList) {
            let _tempObj = {}
            if (item.field_label === 'Subject') {
              _tempObj = {
                headerName: 'Subject',
                field: 'subject',
                filter: true,
                minWidth: 100,
                resizable: true,
                editable: false,
                table_name:item.table_name,
                comparator:(valueA) => {},
                cellRendererFramework: Vue.extend(SubjectComponent),
                tooltipField: 'subject',
                tooltipComponentParams: { color: '#fff' },
                floatingFilterComponentParams: {
                  suppressFilterButton: false
                }

              }
              displayColomns.push(_tempObj)
            } else {
              _tempObj = {
                headerName: item.field_label,
                field: item.field_name,
                filter: true,
                minWidth: 100,
                resizable: true,
                editable: false,
                table_name:item.table_name,
                comparator: (valueA) => {}

              }
              displayColomns.push(_tempObj)
            }

          }
          const staticField2 = {
            headerName: '#',
            field: 'row_index',
            filter: false,
            minWidth: 100,
            maxWidth: 100,
            sortable: false,
            editable: false,
            valueGetter:(params) => {
              return ((this.meta.limit * (this.meta.current_page - 1)) + params.node.rowIndex + 1)
            }
          }
          displayColomns.unshift(staticField2)
          const _tempObj = {
            headerName: 'Actions',
            field: 'actions',
            minWidth: 170,
            maxWidth: 170,
            resizable: true,
            editable: false,
            sortable:false,
            cellRendererFramework: 'CellRendererAction',
            cellRendererParams: {type: 'coursework', fetchAssignmentList:this.fetchAssignmentList}
          }
          displayColomns.push(_tempObj)

        }


        this.columnDefs = displayColomns

        this.gridOptions.api.setColumnDefs(displayColomns)
        this.gridOptions.api.refreshCells({ force: true })
        // console.log(this.gridOptions)
      } catch (e) {
        console.warn(e)
      }
    },
    closeRearrangementModal (value) {
      if (value) {
        this.columnRearrangementModal = false
      }
    },
    columnRearrangement () {
      this.columnRearrangementModal = true
    },
    async sortFun () {
      const sortState = this.gridApi.getSortModel()
      if (sortState.length === 0) {
        // console.log('No sort active')
        this.sorting_obj = {
          attribute : '',
          direction: '',
          field_type: 'system'
        }
      } else {
        this.sorting_obj.field_type = 'system'
        this.sorting_obj.attribute = sortState[0].colId
        this.sorting_obj.direction = sortState[0].sort
      }
      this.fetchAssignmentList()
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.fetchAssignmentList()
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    paginationPageSize () {
      return this.pageLimitSet
    },
    handlePageChange (page) {

      // const tags = this.tagSelected.map((element) => {
      //   return element.id
      // })

      setTimeout(() => {
        const queryPayload = Object.assign({}, this.$route.query)
        queryPayload.user_type = this.searchByLeadType
        // queryPayload.tag_ids = tags
        queryPayload.page = page
        queryPayload.limit = this.pageLimitSet
        // queryPayload.search = this.search
        queryPayload.customerId = this.$store.getters.customerId
        console.log(queryPayload)

        const pageScroll = document.documentElement.scrollTop
        this.$router
          .replace({ path: '/pages/coursework', query: queryPayload })
          .catch(() => {})
          .then(() => {
            document.documentElement.scrollTop = pageScroll
          })
        if (this.select_filter_id === null) {
          this.fetchAssignmentList(queryPayload)
        } else {
          const params = {
            filter_id: this.select_filter_id
          }
          this.fetchAssignmentList(queryPayload, params)
        }
      }, 0)
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    async exportApi () {},
    async fetchAssignmentList (payload_data, filter_id) {
      try {
        this.$vs.loading()

        const customerId = this.$store.getters.customerId
        const payload = {
          custom: 0,
          assignment_type_id: 2,
          parent_id: 0,
          search:this.search,
          limit:this.pageLimitSet
        }
        if (payload_data) payload_data.assignment_type_id = 2
        const data = await listAssignment(
          payload_data || payload,
          customerId,
          this.meta.current_page,
          this.sorting_obj,
          'courseWork_template_table',
          filter_id
        )

        this.AssignmentList = data.data.data.assignmentlist
        this.meta = data.data.data.meta
        this.rowData = this.AssignmentList
        this.noOfFilesInEachAssignment(this.AssignmentList)

      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    reditectToCreateNewView () {
      this.$router.push({
        name: 'QuestionsV2',
        params: { formType: 'Create', type:'Coursework', redirection_from: '2', assignmentApplicationType: 'General' }
      })
    },
    handlefilterSidebar () {
      this.filterSidebarBoolean = !this.filterSidebarBoolean
      document.body.classList.add('overflow-hidden')
    },
    fetchingDynamicFieldAndFilter () {
      /* const customField = this.fetch_customfields_list('Coursework')
      customField.then((responseData) => {
        if (responseData) {
          this.fetchFieldAndFilterList('Coursework') //this is fetching dynamic field and static field for filter modules
        }
      }) */
      this.fetchFieldAndFilterList('Coursework', 'courseWork_template_table') //this is fetching dynamic field and static field for filter modules
    },
    overallSearch () {
      this.overallSearchHolder = !this.overallSearchHolder
    },
    searchByfilter () {
      const tags = this.tagSelected.map((element) => {
        return element.id
      })

      const payload = {
        user_type: this.searchByLeadType,
        tag_ids: tags,
        page: 1,
        limit: this.pageLimitSet,
        customerId: this.$store.getters.customerId
      }

      this.fetchAssignmentList(payload)
    },
    resetSearch () {
      this.select_filter_id = null
      this.tagSelected = []
      this.searchByLeadType = ''
      this.search = ''
      this.handlePageChange(1)
    },
    getFilterByLead () {
      const query = {
        page: 1,
        limit: this.pageLimitSet,
        customerId: this.$store.getters.customerId
      }
      if (this.select_filter_id === null) {
        this.fetchAssignmentList(query)
      } else {
        const params = {
          filter_id: this.select_filter_id
        }
        this.fetchAssignmentList(query, params)
      }
    }
  }
}
</script>

<style scoped>
</style>
